import memoize from 'js/lib/memoize';

import { memoizedCatalogData } from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import Membership from 'bundles/catalogP/models/membership';

const membershipsData = function (options: $TSFixMe) {
  return memoizedCatalogData(catalogUrl.build(Membership.prototype.resourceName, options));
};

export default membershipsData;
export const memoizedMembershipsData = memoize(membershipsData);
